import * as Yup from "yup";
import { enums } from "../constants/enum";
import { getNextDate } from "../util/dateHelpers";

const objectIdValidator = Yup.string()
  .trim()
  .matches(/^[0-9a-fA-F]{24}$/, "Invalid ID format");

const sentTimeValidator = Yup.date()
  .min(getNextDate(-1), "Sent time must be a future date")
  .typeError("Invalid date format for sent time");

export const smsNotificationValidationSchema = Yup.object().shape({
  to: Yup.array()
    .of(
      objectIdValidator
        .required("Recipient ID is required")
        .typeError("Valid Recipient ID is required"),
    )
    .test("unique", "Recipient IDs must be unique", (value) => {
      return !value || new Set(value).size === value.length;
    })
    .when("group", {
      is: (group) => !!group,
      then: (schema) => schema.optional(),
      otherwise: (schema) =>
        schema
          .required("Recipients are required when no group is selected")
          .min(
            1,
            "At least one recipient is required when no group is selected",
          ),
    }),

  group: objectIdValidator.nullable().optional(),

  message: Yup.string()
    .trim()
    .min(1, "Message content must be at least 1 character long")
    .max(1500, "Message content cannot exceed 1500 characters")
    .required("Message content is required"),

  smsContentNature: Yup.string()
    .trim()
    .oneOf(
      [enums.MESSAGE_TYPES.TRANSACTIONAL, enums.MESSAGE_TYPES.PROMOTIONAL],
      "Invalid SMS content nature",
    )
    .required("SMS content nature is required")
    .default(enums.MESSAGE_TYPES.TRANSACTIONAL),

  type: Yup.string()
    .trim()
    .oneOf(
      [enums.MESSAGE_TYPES.INSTANT, enums.MESSAGE_TYPES.SCHEDULE],
      "Invalid message type",
    )
    .required("Message type is required")
    .default(enums.MESSAGE_TYPES.INSTANT),

  scheduleDate: Yup.date().when("type", {
    is: enums.MESSAGE_TYPES.SCHEDULE,
    then: (schema) =>
      sentTimeValidator.required(
        "Sent time is required for scheduled messages",
      ),
    otherwise: (schema) => schema.nullable().optional(),
  }),

  scheduleTime: Yup.date().when("type", {
    is: enums.MESSAGE_TYPES.SCHEDULE,
    then: (schema) =>
      Yup.string().required("Sent time is required for scheduled messages"),
    otherwise: (schema) => schema.nullable().optional(),
  }),
});

